import * as Actions from '../actions/notifications.actions';

const initialState = {
  broadcasts: [],
  total: 0,
  page: 0,
  loading: false,
  recipientsPreview: null,
  accounts: [],
  users: [],
};

const notifications = (state = initialState, action = {}) => {
  switch (action.type) {
    case Actions.GET_BROADCASTS: {
      return {
        ...state,
        broadcasts: action.payload.data,
        total: action.payload.total,
        page: action.payload.page,
      };
    }

    case Actions.SET_BROADCASTS_LOADING: {
      return { ...state, loading: action.payload };
    }

    case Actions.SET_RECIPIENTS_PREVIEW: {
      return { ...state, recipientsPreview: action.payload };
    }

    case Actions.GET_AUDIENCE_OPTIONS: {
      return {
        ...state,
        accounts: action.payload.accounts,
        users: action.payload.users,
      };
    }

    default:
      return state;
  }
};

export default notifications;
